@if (showLoadingState()) {
  <mwe-basic-card [hasBackground]="false">
    <dotlottie-player
      class="mx-auto mb-5"
      aria-hidden="true"
      autoplay
      loop
      playMode="normal"
      id="dot-lottie-confirmation-loading"
      src="/assets/loading-animation/windmills.lottie"
      playerId="dot-lottie-confirmation-loading"
      style="max-width: 273px; display: block"
      dontFreezeOnBlur="true"
    ></dotlottie-player>
    <h1
      data-test="mwe-confirmation-view-header-loading"
      class="h3 text-center"
      [class.mb-0]="!workInProgressSubtextKey()"
      [translate]="workInProgressMsgKey()"
    ></h1>
    @if (workInProgressSubtextKey()) {
      <span class="text--large text-center d-block" [translate]="workInProgressSubtextKey()"></span>
    }
  </mwe-basic-card>
}
@if (showErrorState()) {
  @if (errorTitleKey()) {
    <h1 class="mb-5 mb-md-6">{{ errorTitleKey() | translate }}</h1>
  }
  @if (errorMsgTitleKey()) {
    <div class="mb-5" data-test="mwe-confirmation-view-error">
      <mwe-inline-notification
        type="danger"
        [titleKey]="errorMsgTitleKey()"
        headingNodeType="h2"
        [messageKey]="retryAllowed() && errorMsgRetryKey() ? errorMsgRetryKey() : errorMsgKey()"
        [placeholderMap]="alertPlaceholders()"
        [ctaLabelKey]="ctaLabelKey()"
        (onCTAClick)="handleCTAClick()"
      ></mwe-inline-notification>
    </div>
  }
  @if (steps().length) {
    <h2 class="h4 mb-4">{{ 'globalConfirmation.stepsHeading' | translate }}</h2>
    <div class="mb-5 mb-md-6">
      <mwe-basic-card [hasBackground]="false">
        <ng-container *ngTemplateOutlet="stepsList; context: { steps: steps() }" />
      </mwe-basic-card>
    </div>
  }
}
@if (showSuccessState()) {
  @if (infoSteps()?.length) {
    <mwe-basic-card data-test="mwe-confirmation-view-success-info">
      <mwe-next-steps [stepsTitle]="infoTitleKey()" [infoSteps]="infoSteps()" [processTitle]="processTitle()">
        <div class="text-center"><img [src]="'confirmation-success.svg' | addStaticImagePath" alt="Erfolg" class="mb-5" /></div>
      </mwe-next-steps>
    </mwe-basic-card>
  } @else {
    <mwe-basic-card [hasBackground]="false" data-test="mwe-confirmation-view-success-no-info">
      <div class="d-flex flex-column align-items-center">
        <img src="/assets/img/success-animation_no_text.gif" alt="Success" class="mx-auto mb-5" style="max-width: 214px" />
        @if (successMsgKey()) {
          <h1 class="h4" data-test="mwe-confirmation-view-header-success" [translate]="successMsgKey()"></h1>
        }
        @if (successSubtextKey()) {
          <span class="text--large text-center d-block" [translate]="successSubtextKey()"></span>
        }
      </div>
    </mwe-basic-card>
  }
}

<ng-template #stepsList let-steps="steps">
  @for (item of steps; track item; let last = $last) {
    @if (stepRenderer()) {
      <ng-container *ngComponentOutlet="stepRenderer(); inputs: { step: item.step, state: item.state }" />
    } @else {
      <div class="row gx-3 gy-1 align-items-center" [ngClass]="{ 'mb-3': !last }">
        @if (getIconClassForStep(item)) {
          <div class="col-auto">
            <mwe-badge
              emphasis="bold"
              [iconClass]="getIconClassForStep(item)"
              size="sm"
              [type]="getBadgeTypeForStep(item)"
              [text]="getBadgeLabelForStep(item)"
            />
          </div>
        }
        <div class="col-sm">
          <span
            class="backend-process-step-title"
            [translate]="getTitleForStep(item)"
            [translateParams]="item.step.translationParams"
          ></span>
          @for (label of getLabelsForStep(item); track $index) {
            &nbsp;<span class="backend-process-step-label" [translate]="label" [translateParams]="item.step.translationParams"></span>
          }
        </div>
      </div>
    }
  }
</ng-template>
